import React from "react";
import ReactDOM from "react-dom";
import ContentContributorInfo from "../ContentContributorInfo/components";
import ContentEndorsers from "../ContentEndorsers";
import ContentKey from "../ContentKey";
import ContentKeyMobile from "../ContentKeyMobile";
import ContentRightRailImage from "../ContentRightRailImage";
import ContentRightRailVideo from "../ContentRightRailVideo";
import RightRailRelatedContent from "../RightRailRelatedContent";
import RightRailRelatedTopics from "../RightRailRelatedTopics";
import ContentRightRailAlgorithm from "../ContentRightRailAlgorithm";
import ContentRightRailDDTools from "../ContentRightRailDDTools";
import ContentRightRailTable from "../ContentRightRailTable";
import { affordances } from "../../util/analytics";

import { RightRailWrap } from "./_styled";

const ContentRightRail = ({
  ancillaryData = [],
  contributors = [],
  endorsers = [],
  multimedia = {},
  handleAlgorithmCTA,
  handleOpenAlgorithmPDF,
  handleOpenLightBoxImage,
  handleOpenLightBoxVideo,
  handleOpenTable,
  isNonFreePreview,
  isContributorNamesDialogEnabled,
  slugTitle,
  slugPubType,
  isMobile,
  isTablet,
  tablesContent,
  setIsDialogOpen,
  setTableData,
  telemetryData,
}) => {
  const typeToAncillaryComponentMapping = {
    KeySection: ContentKey,
    ImageRightRailSection: ContentRightRailImage,
    VideoRightRailSection: ContentRightRailVideo,
    AlgorithmRightRailSection: ContentRightRailAlgorithm,
    DDToolsRightRailSection: ContentRightRailDDTools,
    RelatedContentRightRailSection: RightRailRelatedContent,
    RelatedDMTopicsRightRailSection: RightRailRelatedTopics,
    TablesRightRailSection: ContentRightRailTable,
  };

  const keyButton = document.getElementById("toolbar-btn");
  const keyData = ancillaryData.find((data) => data.type === "KeySection");

  return (
    <RightRailWrap>
      {endorsers?.length > 0 &&
        endorsers.map((endorser) => <ContentEndorsers endorser={endorser} />)}
      {contributors.length > 0 && (
        <ContentContributorInfo
          contributors={contributors}
          isContributorNamesDialogEnabled={isContributorNamesDialogEnabled}
        />
      )}
      {ancillaryData.map(({ type, ...rest }, idx) => {
        const Component = typeToAncillaryComponentMapping[type];

        if (type === "ImageRightRailSection") {
          // If we're rendering the Images Right Rail section, pass in images
          rest.images = multimedia.images;
          rest.handleOpenLightBoxImage = () => {
            handleOpenLightBoxImage(0, affordances.RIGHT_RAIL);
          };
        } else if (type === "VideoRightRailSection") {
          // If we're rendering the Videos Right Rail section, pass in videos
          rest.videos = multimedia.videos;
          rest.handleOpenLightBoxVideo = () => {
            handleOpenLightBoxVideo(0, affordances.RIGHT_RAIL);
          };
        } else if (type === "AlgorithmRightRailSection") {
          // If we're rendering the Algorithms Right Rail section, pass in algorithms
          rest.algorithms = multimedia.algorithms;
          rest.handleOpenAlgorithmPDF = handleOpenAlgorithmPDF;
          rest.handleAlgorithmCTA = handleAlgorithmCTA;
          rest.isNonFreePreview = isNonFreePreview;
        } else if (type === "TablesRightRailSection") {
          // If we're rendering the Tables Right Rail section, pass in tables
          rest.tablesContent = tablesContent;
          rest.setIsDialogOpen = setIsDialogOpen;
          rest.setTableData = setTableData;
          rest.isNonFreePreview = isNonFreePreview;
          rest.handleOpenTable = handleOpenTable;
        } else {
          //There is nothing to do here so Sonar be happy please
        }

        rest.slugTitle = slugTitle;
        rest.slugPubType = slugPubType;
        rest.isMobileDevice = isMobile;
        rest.isTabletDevice = isTablet;
        rest.telemetryData = telemetryData;

        return Component && <Component key={idx} {...rest} />;
      })}
      {keyButton &&
        keyData &&
        ReactDOM.createPortal(
          <ContentKeyMobile content={keyData.content} />,
          keyButton
        )}
    </RightRailWrap>
  );
};

ContentRightRail.displayName = "ContentRightRail";

export default ContentRightRail;
